import { EventProps } from 'react-big-calendar';
import { displaySessionTimeRange } from '../../../../utils/dateUtils';
import { hasPendingSubRequest } from '../../../../utils/lessonInstructorUtils';
import { Event } from '../SFCCalendar';
import { CalendarTraineeObserverNote } from './CalendarTraineeObserverNote';

export const EventCell = ({
  event,
  filteredInstructorId
}: EventProps<Event> & { filteredInstructorId?: number | null }) => {
  const timeDisplay =
      displaySessionTimeRange(
          event.lesson?.calculated_starts_at ?? event.lesson?.course?.starts_at,
          event.lesson?.calculated_ends_at ?? event.lesson?.course?.ends_at,
          (event.lesson?.course?.venue as any)?.location?.timezone,
      ) || event.lesson?.formatted_time;

  const pendingSub =
    filteredInstructorId &&
    event.lesson?.lesson_assignments &&
    hasPendingSubRequest(event.lesson.lesson_assignments, filteredInstructorId);

  return (
      <div
          className="d-none d-lg-block custom-event-cell"
          style={{ fontSize: 12 }}
      >
        <span className="fw-bold">{event.title}</span>
        <br />
        <span>{timeDisplay}</span>
        {pendingSub && (
          <>
            <br />
            <span style={{ fontSize: 11, fontStyle: 'italic', opacity: 0.9 }}>Sub requested</span>
          </>
        )}
        <CalendarTraineeObserverNote
          lesson={event.lesson}
          course={event.lesson?.course}
          viewerInstructorId={filteredInstructorId}
        />
      </div>
  );
};